import styles from './Spinner.module.scss';

function Spinner() {
  return <div className={styles.Spinner} />;
}

export default Spinner;
